module.exports = [
    {
        name: 'Mazda 3 Hatchback',
        nicename: '3',
        modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885837&PluID=0&ord=[timestamp]',
        impressionTracker1:
            'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885837&PluID=0&ord=[timestamp]&rtu=-1',
        impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037120/skeleton.gif',
        img: {
            wired: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885844&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037094/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885844&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/170111_2017_Mazda3_5dr_Wired.jpg'
            },
            mobile: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885866&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037222/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885866&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/mobile/170111_2017_Mazda3_5dr_277x55.jpg'
            }
        },
        link: {
            wired: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885837&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885837&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037120/skeleton.gif'
            },
            mobile: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885851&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885851&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037236/skeleton.gif'
            }
        }
    }
];


//////////////////
// WEBPACK FOOTER
// ./src/interlock/nav-sponsorship/constants/hatchback.js
// module id = 60
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14